<div
  [innerHTML]="htmlString"
  class="wordwrap"
  [ngClass]="{ 'new-line': newline }"
></div>
